import { render, staticRenderFns } from "./editFullReduction.vue?vue&type=template&id=38bac7ba&scoped=true&"
import script from "./editFullReduction.vue?vue&type=script&lang=js&"
export * from "./editFullReduction.vue?vue&type=script&lang=js&"
import style0 from "./editFullReduction.vue?vue&type=style&index=0&id=38bac7ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bac7ba",
  null
  
)

export default component.exports